import React from 'react';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Button, { ILink } from 'tbk-components/src/components/Button';
import Icon, { IIconProps } from 'tbk-components/src/components/Icon';

export interface CtaButton {
	icon: IIconProps;
	button: ILink;
}

export interface CtaBox {
	ctaBoxImage?: IImage;
	title?: string;
	ctaButton?: CtaButton;
}

export interface IHeroBannerWithCtaBoxProps {
	headingFirstLine?: string;
	headingSecondLine?: string;
	image?: IImage;
	ctaBoxes?: CtaBox[];
}

/**
 * Hero Banner With Cta Box
 * @block
 * @icon format-image
 */
const HeroBannerWithCtaBox: React.FC<IHeroBannerWithCtaBoxProps> = ({
	headingFirstLine,
	headingSecondLine,
	image,
	ctaBoxes = [],
}) => {
	return (
		<div className="hero-banner-with-cta-box__container">
			<div className="hero-banner-with-cta-box__container-inner">
				<div className="hero-banner-with-cta-box__upper">
					{(headingFirstLine || headingSecondLine) && (
						<h1>
							{headingFirstLine && (
								<span>{headingFirstLine}</span>
							)}
							{headingSecondLine && (
								<span>{headingSecondLine}</span>
							)}
						</h1>
					)}
					{image && <Image {...image} />}
				</div>
				<div className="hero-banner-with-cta-box__lower">
					<div className="hero-banner-with-cta-box__lower-inner">
						{ctaBoxes.length > 0 &&
							ctaBoxes.map((cta, index) => {
								return (
									<div
										key={index}
										className="hero-banner-with-cta-box__cta"
									>
										<div className="hero-banner-with-cta-box__cta-inner">
											{cta?.ctaBoxImage && (
												<div className="hero-banner-with-cta-box__cta-inner-image">
													<Image
														{...cta?.ctaBoxImage}
													/>
												</div>
											)}
											{cta?.title && (
												<span>{cta?.title}</span>
											)}
											{cta?.ctaButton?.button?.href && (
												<Button
													{...cta?.ctaButton?.button}
													className="btn btn-primary btn-lg"
												>
													<Icon
														{...cta?.ctaButton
															?.icon}
													/>
												</Button>
											)}
										</div>
									</div>
								);
							})}
					</div>
				</div>
			</div>
		</div>
	);
};

export default HeroBannerWithCtaBox;
